import { Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";

import { ModalController, Platform } from "@ionic/angular";
import { Observable } from "rxjs";

import { ConfigurationService } from "../../services/configuration.service";
import { Flyer } from "../../models/flyer.model";
import { Product } from "../../models/produto.model";
import { RestaurantService } from "../../services/restaurant.service";
import { V2ItemPage } from "../../shared/components/v2/v2-item/v2-item.page";
import { V2TopBarOptions } from "../../shared/components/v2/v2-top-bar/v2-top-bar.component";
import { Restaurant } from "../../models/restaurant.model";
import { environment } from "src/environments/environment";
import { StorageService } from "src/app/services/storage.service";
import { ToastaddService } from "src/app/services/toastadd.service";
import { take } from "rxjs/operators";

@Component({
  selector: "app-v2-home",
  templateUrl: "./v2-home.page.html",
  styleUrls: ["./v2-home.page.scss"],
})
export class V2HomePage implements OnInit {
  public slideOptions = {
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    loop: true,
  };
  /**
   * Promoções em loop
   */
  public flyers$: Observable<Flyer[]>;
  /**
   * Modo de uso do app
   */
  public appMode$: Observable<string>;
  /**
   * Diz se o app está sendo usado como 'rest' em tablets ou 'user' no celular do cliente final
   */
  public breed$: Observable<string>;
  public rest$: Observable<Restaurant>;
  public restauranteNome: string;
  isFab: boolean = false;
  isSocials: boolean = true;

  constructor(
    public config: ConfigurationService,
    private modalCtrl: ModalController,
    private restService: RestaurantService,
    private storage: StorageService,
    private platform: Platform,
    private alerta: ToastaddService,
    private route: Router
  ) {
    console.log(this.config.isSmall, "small1");

    platform.ready().then(() => {
      if (platform.width() >= 800 && platform.height() >= 400) {
        this.config.isTablet = true;
      }
      if (platform.height() <= 700) {
        this.config.isSmall = true;
      }
    });
    console.log(this.config.isSmall, "small2");
  }

  ngOnInit() {
    /* Verifica o cnpj para coletar o pixel (cnpj utilizado é do MaxBurguer) */
    if(environment.cnpjRest == '27180422000142') {
      let facePixelID = '1021518738964214'
      sessionStorage.setItem('pixelFace', facePixelID)
    }
    else {
      sessionStorage.setItem('pixelFace', null)
    }
    /**/

    this.flyers$ = this.restService.getFlyers();
    this.appMode$ = this.config.getMode();
    this.breed$ = this.config.getBreed();
    this.rest$ = this.restService.getRest();

    this.appMode$.subscribe({
      next: (mode) => (this.config.modoApp = mode),
    });

    this.rest$.subscribe({
      next: (imagem) => (this.config.imagemRest = imagem),
    });

    this.rest$.subscribe({
      next: (restaurante) =>
        (this.config.restauranteId = restaurante.restauranteId),
    });

    this.rest$.subscribe({
      next: (restaurante) => {
        this.config.restaurante = restaurante; 
        console.log('Restaurante carregado:', restaurante);
        console.log('Nome do restaurante', restaurante.nome);
  
      }
    });

    //const mode = this.storage.get(environment.storage.appMode)

    this.appMode$.subscribe((mode) => {
      if (mode === "gestor") {
        this.route.navigate(["v2/cardapio"]);
        //location.href = "../cardapio";
      }
    });
  }

  /* 
  Verifica se o restaurante é o maxBurguer para poder fazer a chamada do pixel.
  a adição do pixel está na página app.component.ts dentro do verificaUrl
  */
  
  maxBurguer(cnpj) {
    if(cnpj == '27180422000142') {
      let facePixelID = '1021518738964214'
      sessionStorage.setItem('pixelFace', facePixelID)
    }
    else {
      sessionStorage.setItem('pixelFace', null)
    }
  }

  /**
   * Chama a página de detalhes do produto
   * @param prod
   */
  callProdDetails(prod: Product) {
    this.modalCtrl
      .create({
        component: V2ItemPage,
        componentProps: {
          prod,
        },
        cssClass: "modal-fullscreen",
      })
      .then((modal) => modal.present());
  }

  /**
   * Abre o site da ZIP em outra guia
   */
  zip() {
    window.open("https://www.zipsoftware.com.br", "_blank", "location=yes");
    //this.alerta.alertaMsg('Versão: 2.6 - ' + this.config.modoApp)
  }

  callGarcom() {
    console.log("garcom");
  }

  callConta() {
    console.log("conta");
  }

  facebook() {
    let facebook = this.config.restaurante.facebook;
    window.open(`https://www.facebook.com/${facebook}`, "_system");
   
  }

  instagram() {

    let instagram = this.config.restaurante.instagram;
   

    if (this.platform.is("ios")) {
      window.open(`instagram://user?username=${instagram}`, "_system");
    } else if (this.platform.is("android")) {
      window.open(`instagram://user?username=${instagram}`, "_system");
    } else {
      window.open(`https://www.instagram.com/${instagram}`, "_system");
    } 
  }

  whatsapp() {
    let whats = this.config.restaurante.whatsapp;
    let msg = "Olá " + this.config.restaurante.nome + "!";
    window.open(`https://api.whatsapp.com/send?phone=55${whats}&text=${msg}`);
  }

  email() {}
}
